// UserLink.tsx - reusable clickable UID. Opens the user-profile
// drawer (mounted at App root) when clicked. Any surface that shows
// a Firebase Auth uid should use this rather than a bare <code>.

import { useUserProfileDrawer } from '@/components/UserProfileDrawer';

interface Props {
  uid: string;
  /** When true, render the first 6 + last 4 chars (e.g. 092d54...6090).
   *  Default false - show the full uid (caller controls truncation
   *  via column width / wrapping). */
  truncate?: boolean;
  /** Optional prefix label (e.g. "install:") rendered inside the
   *  monospace block but not part of the click target's meaning. */
  prefix?: string;
}

function shorten(uid: string): string {
  if (uid.length <= 12) return uid;
  return `${uid.slice(0, 6)}…${uid.slice(-4)}`;
}

export function UserLink({ uid, truncate = false, prefix }: Props) {
  const { openUid } = useUserProfileDrawer();
  const label = truncate ? shorten(uid) : uid;
  return (
    <button
      type="button"
      onClick={() => openUid(uid)}
      className="console-user-link"
      title={uid}
    >
      <code style={{ fontFamily: 'JetBrains Mono, monospace' }}>
        {prefix}
        {label}
      </code>
    </button>
  );
}
